module.exports = __webpack_public_path__ + "static/media/swot.cda52672.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/swot.png
// module id = 892
// module chunks = 0